import auth from '@/router/auth'
import CategoryCourseIndex from '@/components/test-kits-online/Index'
import CategoryCourseCreate from '@/components/test-kits-online/Create'
import CategoryCourseUpdate from '@/components/test-kits-online/Update'
import CategoryCourseShow from '@/components/test-kits-online/Show'
import MultipleChoiceManualCreate from '@/components/test-kits-online/MultipleChoiceManualCreate'
import MultipleChoiceManualUpdate from '@/components/test-kits-online/MultipleChoiceManualUpdate'

export default [
  {
    path: '/test-kits-online',
    name: 'test-kits-online-index',
    component: CategoryCourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-kits-online/create',
    name: 'test-kits-online-create',
    component: CategoryCourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-kits-online/update/:id',
    name: 'test-kits-online-update',
    component: CategoryCourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-kits-online/show/:id',
    name: 'test-kits-online-show',
    component: CategoryCourseShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/multiple-choice-manual/create',
    name: 'multiple-choice-manual-create',
    component: MultipleChoiceManualCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/multiple-choice-manual/update/:id',
    name: 'multiple-choice-manual-update',
    component: MultipleChoiceManualUpdate,
    beforeEnter: auth.requireAuth
  },
]



// WEBPACK FOOTER //
// ./src/components/test-kits-online/router.js